import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RegDetailsModule } from './components/details/details.module';
import { RegSetUpModule } from './components/set-up/set-up.module';
import { RegTermsConditionsModule } from './components/terms-conditions/terms-conditions.module';
import { ThankYouModule } from './components/thank-you/thank-you.module';
import { PendingVerificationModule } from 'src/app/components/pending-verification/pending-verification.module';

@NgModule({
    declarations: [
        RegisterComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ModalModule,
        RegSetUpModule,
        RegDetailsModule,
        RegTermsConditionsModule,
        ThankYouModule,
        PendingVerificationModule
    ]
})
export class RegisterModule {}
